module.exports = __webpack_public_path__ + "img/crypto.b19ad2ac.jpg";